import { Text } from '@arc-ui/components';
import { ResultsHeaderProps } from '../../../types/results';

export const ResultsHeader: React.FC<ResultsHeaderProps> = ({
  query,
  activeFacet,
  initialHitCount,
  align = 'left',
}) => {
  if (activeFacet) {
    return (
      <Text elementType="p" size="m" align={align}>
        <strong>{activeFacet.count.toLocaleString()}</strong> results found for{' '}
        <strong>&quot;{query}&quot;</strong> in{' '}
        <strong>&quot;{activeFacet.label}&quot;</strong>
      </Text>
    );
  }

  return (
    <Text elementType="p" size="m" align={align}>
      <strong>{initialHitCount.toLocaleString()}</strong> results found for{' '}
      <strong>&quot;{query}&quot;</strong>
    </Text>
  );
};
